import React from 'react';

import Spinner from './Spinner';

const SmallButton = ({ title, type, color, loading, onClick }) => {

  const isLoading = loading ? "btn-opacity" : "";

  return (
    <button onClick={onClick} disabled={loading} type={type} className={`my-btn-small btn-small btn-${color} ${isLoading}`}>
      {loading ? (
        <div style={{marginTop: "2px", marginBottom: "2px"}} className="spinner-center">
          <Spinner />
        </div>
      ):(
        title
      )}
    </button>
  );
}

export default SmallButton;